
export default {
  myProfile: {},
  myToken: '',
  myRefreshToken: '',
  sendNextRefreshRequestIn: new Date().getTime(),
  userPermissions: []
}
